// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"ef75d4f5","405":"c0989b53","443":"aec65a3a"}[chunkId] + ".css";
};